/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfStageDto } from "../models/AjaxResponseOfListOfStageDto";
import type { AjaxResponseOfStageDto } from "../models/AjaxResponseOfStageDto";
import type { CreateOrUpdateStageDto } from "../models/CreateOrUpdateStageDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class StageAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfStageDto Success
   * @throws ApiError
   */
  public createOrUpdateStage({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateStageDto;
  }): CancelablePromise<AjaxResponseOfStageDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/stages",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfListOfStageDto Success
   * @throws ApiError
   */
  public reorderStages({
    salesKanbanId,
    requestBody,
  }: {
    salesKanbanId: number;
    requestBody?: Array<number>;
  }): CancelablePromise<AjaxResponseOfListOfStageDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/stages/reorder/{salesKanbanId}",
      path: {
        salesKanbanId: salesKanbanId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfListOfStageDto Success
   * @throws ApiError
   */
  public getAllStages({
    salesKanbanId,
  }: {
    salesKanbanId: number;
  }): CancelablePromise<AjaxResponseOfListOfStageDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/stages/sales-kanban/{salesKanbanId}",
      path: {
        salesKanbanId: salesKanbanId,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteStage({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/stages/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfStageDto Success
   * @throws ApiError
   */
  public getStage({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfStageDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/stages/{id}",
      path: {
        id: id,
      },
    });
  }
}
